module.exports = __webpack_public_path__ + "img/04.1e5ae7a3.png";